export const scrollToVisibleSelector = selector => {
  const domEl = document.querySelector(selector);
  if (domEl && domEl.scrollIntoView) {
    setTimeout(
      () => domEl.scrollIntoView({ behavior: 'smooth', block: 'start' }),
      300
    );
  }
};



// WEBPACK FOOTER //
// ./src/helpers/dom.js